module.exports = __webpack_public_path__ + "static/media/preApprovalArrow.ee38635e.svg";